import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import { Checkbox, TextField, Button, Backdrop } from '@material-ui/core'
import Autocomplete, {
  createFilterOptions
} from '@material-ui/lab/Autocomplete'
import {
  actions
} from '../../listView.reducer'
import { ListViewDispatchContext, ListViewStateContext } from '../../listView.context'
import CircularProgress from '@material-ui/core/CircularProgress'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'

import { massProcessingApi } from '@atheneum/api'

const filter = createFilterOptions()
const move = () => true

const CustomColorCheckbox = withStyles({
  root: {
    color: '#429BDC',
    '&$checked': {
      color: '#429BDC'
    }
  },
  checked: {}
})(props => <Checkbox color="default" {...props} />)

export const copyMoveStages = [
  {
    validators: [],
    component: CopyMoveDialog,
    full: false
  },
  {
    validators: [],
    component: CopyDone,
    full: false
  }
]

export const copy = {
  name: 'copy',
  title: 'Copy to List',
  component: CopyOrMoveComponent,
  stages: copyMoveStages,
  loadStage: 0,
  finishAction: move
}

function CopyOrMoveComponent({ items, list }) {
  const [allLists, setAllLists] = React.useState()
  const [listLoaded, setListLoaded] = React.useState(false)

  const dispatch = React.useContext(ListViewDispatchContext)
  const state = React.useContext(ListViewStateContext)
  const [listToShare, setListToShare] = React.useState({})
  const [removeFromCurrent, setRemoveFromCurrent] = React.useState(true)
  const [runningAction, setRunningAction] = React.useState(false)

  React.useEffect(() => {
    ;(async () => {
      const getAllLists = await massProcessingApi.getLists()
      setAllLists(getAllLists)
      setListLoaded(true)
    })()
  }, [])

  return copy.stages.map((stage, index) => {
    return (
      state.massAction.stage === index &&
      stage.component({
        items,
        list,
        allLists,
        listLoaded,
        state,
        listToShare,
        setListToShare,
        removeFromCurrent,
        setRemoveFromCurrent,
        dispatch,
        runningAction,
        setRunningAction
      })
    )
  })
}

function CopyMoveDialog({
  state,
  items,
  list,
  allLists,
  listLoaded,
  listToShare,
  setListToShare,
  removeFromCurrent,
  setRemoveFromCurrent,
  dispatch,
  runningAction,
  setRunningAction
}) {
  if (state.massAction?.id) {
    dispatch({
      type: actions.NEXT_STAGE
    })
  }

  if (!listLoaded)
    return (
      <Backdrop
        style={{
          zIndex: 999
        }}
        open={true}>
        <CircularProgress style={{ color: '#429bdc' }} />
      </Backdrop>
    )

  const copyDisabled = !listToShare.id && !removeFromCurrent
  return (
    <div style={{ display: 'flex', width: '500px', alignItems: 'flex-end' }}>
      <Autocomplete
        onChange={async (_event, newValue) => {
          if (newValue.id === 'new') {
            const newList = await massProcessingApi.createList({
              name: newValue.name,
              type: 'expert'
            })
            setListToShare(newList)
          } else {
            setListToShare(newValue)
          }
        }}
        filterOptions={(options, params) => {
          const filtered = filter(options, params)

          // Suggest the creation of a new value
          if (params.inputValue !== '') {
            filtered.push({
              id: 'new',
              label: `new: "${params.inputValue}"`,
              name: params.inputValue
            })
          }

          return filtered
        }}
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        id="free-solo-with-text-demo"
        options={allLists}
        getOptionLabel={option => option.name}
        renderOption={option => option.label || option.name}
        style={{ width: '100%' }}
        freeSolo
        renderInput={params => (
          <TextField {...params} label="Select or create new List" />
        )}
      />
      <div
        style={{
          cursor: 'pointer',
          textAlign: 'end',
          width: '650px',
          display: 'flex',
          alignItems: 'center'
        }}>
        <span
          style={{ width: '180px' }}
          onClick={() => setRemoveFromCurrent(!removeFromCurrent)}>
          <CustomColorCheckbox
            edge="start"
            checked={removeFromCurrent}
            tabIndex={-1}
            disableRipple
          />
          Delete from current list
        </span>
        <span
          style={{ marginLeft: '10px' }}
          className={
            copyDisabled ? 'al-text-button-disabled' : 'al-text-button'
          }
          disabled={copyDisabled}
          onClick={async () => {
            if (copyDisabled) return
            setRunningAction(true)
            await massProcessingApi.createMassAction({
              listId: list.id,
              type: 'copy',
              data: {
                newListId: listToShare.id,
                move: removeFromCurrent
              },
              actions: items.map(item => ({
                listItemId: item.id
              }))
            }).then(mp => {
              dispatch({
                type: actions.CREATE_MASS_ACTION_DONE,
                payload: mp.id
              })
            })

            setRunningAction(true)
          }}>
          {(() => {
            if (removeFromCurrent) {
              return listToShare.id ? 'Move' : 'Delete'
            } else {
              return 'Copy'
            }
          })()}
        </span>
        <span
          style={{ marginLeft: '10px' }}
          className={`al-text-button`}
          onClick={() => {
            dispatch({
              type: actions.END_ACTION
            })
          }}>
          Cancel
        </span>
        {runningAction && (
          <CircularProgress
            style={{
              marginLeft: '10px',
              width: '25px',
              height: '25px',
              color: '#429bdc'
            }}
          />
        )}
      </div>
    </div>
  )
}

function CopyDone({ dispatch, state, listToShare }) {
  return (
    <div style={{ marginLeft: '10px' }}>
      Items are being processed
      <Button
        onClick={() => {
          dispatch({ type: actions.END_ACTION })
          massProcessingApi.stopMassAction(state.massAction.id)
        }}>
        Stop
      </Button>
      {!!listToShare?.id && (
        <Button
          style={{
            background: 'transparent',
            color: '#429bdc',
            marginLeft: '10px',
            height: '30px'
          }}
          onClick={() => {
            window.location.href = `/list/${listToShare.id}`
          }}>
          Go to list
          <ChevronRightIcon
            style={{
              color: '#429bdc',
              width: '30px',
              height: '30px'
            }}
          />
        </Button>
      )}
    </div>
  )
}
